import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, useAnimation, AnimatePresence } from "framer-motion";
import subscriptionAnimation from "../../../loader/subscription.json";
import Lottie from "lottie-react";

export default function EmptySubscription() {
  const navigate = useNavigate();
  const controls = useAnimation();

  useEffect(() => {
    const sequence = async () => {
      await controls.start("visible");
      controls.start({
        y: [0, -8, 0],
        transition: {
          repeat: Infinity,
          repeatType: "reverse",
          duration: 2.5,
          ease: "easeInOut",
        },
      });
    };
    sequence();
  }, [controls]);

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const item = {
    hidden: { y: 15, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 100,
      },
    },
  };

  return (
    <motion.div
      className="flex flex-col items-center justify-center h-[60vh] text-center px-2"
      variants={container}
      initial="hidden"
      animate={controls}
    >
     <div className="relative mb-8">
  <motion.div
    className="relative"
    animate={{
      scale: [1, 1.05, 1],
    }}
    transition={{
      repeat: Infinity,
      repeatType: "reverse",
      duration: 2,
      ease: "easeInOut"
    }}
  >
    <Lottie
      animationData={subscriptionAnimation}
      loop
      className="w-32 h-32 mx-auto"
    />
    <div className="absolute inset-0 bg-[#FF7236] rounded-full opacity-10 blur-lg scale-110" />
  </motion.div>
</div>


      <motion.h2
        variants={item}
        className="text-3xl font-bold text-text-black mb-3"
      >
        No Subscription Found
      </motion.h2>
      <motion.p variants={item} className="text-lg text-gray-600 max-w-md mb-6">
        You're missing out! Pick a plan and start enjoying unlimited book
        rentals.
      </motion.p>

      <motion.button
        variants={item}
        onClick={() => navigate("/membershipPlans")}
        className="mt-2 px-8 py-3.5 bg-white border-2 border-primary rounded-full text-primary font-medium relative overflow-hidden group"
        whileHover={{
          scale: 1.05,
          backgroundColor: "#FF7236",
          color: "#fff",
          boxShadow: "0 10px 25px rgba(255, 114, 54, 0.3)",
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        Explore Plans
      </motion.button>
    </motion.div>
  );
}
